import { getDateWithoutTimezoneShift } from '@lender/utils';
import { formatToPercents } from 'app/pages/loanApplication/LoanApplication.utils';
import dayjs from 'dayjs';
import _ from 'lodash';

import { COMMON_DATE_FORMAT } from 'constants/date';
import { DynamicValueType } from 'constants/dynamicValues';
import { loanStatus } from 'constants/loanApplication';
import { getProgressPercentageDetails } from 'utils/loanProgress';
import { formatNumberToCurrencyString } from 'utils/number';
import { pascalCaseToStartCase } from 'utils/string';

const excludedPercentFields = ['dti', 'previous dti'];

export const formatDynamicValue = (
  { value, field, type, dateFormat = COMMON_DATE_FORMAT, dynamicFieldName },
  {
    progressPercentage: legacyProgressPercentage,
    milestoneProgress,
    statusDescription,
    percentDescription,
  } = {},
) => {
  if (_.isNil(value)) {
    return 'N/A';
  }

  const progressPercentageDetails = getProgressPercentageDetails({
    milestoneProgress,
    statusDescription,
    percentDescription,
    legacyProgressPercentage,
  });

  if (field === loanStatus && progressPercentageDetails.isProgressDisplayed) {
    const { status, progress } = progressPercentageDetails;

    return `${status.text} (${progress}%)`;
  }

  if (excludedPercentFields.includes(dynamicFieldName.toLowerCase())) {
    return _.isNumber(value) ? `${value.toFixed(2)}%` : value;
  }

  switch (type) {
    case DynamicValueType.PERCENT:
      return formatToPercents(value);

    case DynamicValueType.RATE:
      return `${value}%`;

    case DynamicValueType.CURRENCY:
      return formatNumberToCurrencyString(value, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        isNullishDisallowed: true,
      });

    case DynamicValueType.DATE:
    case DynamicValueType.TODAY_X_DAYS:
    case DynamicValueType.DATE_X_BUSINESS_DAYS:
      return dayjs(getDateWithoutTimezoneShift(value)).format(dateFormat);

    case DynamicValueType.LOAN_ORIGINATOR_SIGN:
      return '';

    default:
      return pascalCaseToStartCase(value);
  }
};
